import { render, staticRenderFns } from "./IP_HCCSummaryPrintable.vue?vue&type=template&id=2f9d2c8e&scoped=true&"
import script from "./IP_HCCSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_HCCSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_HCCSummaryPrintable.vue?vue&type=style&index=0&id=2f9d2c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9d2c8e",
  null
  
)

export default component.exports